export const toggleColumns = [
  { id: 1, name: "Invoice#" },
  { id: 2, name: "Amount" },
  { id: 7, name: "Date" },
  { id: 5, name: "Type" },
  { id: 6, name: "Source" },
  { id: 8, name: "File#" },
  { id: 9, name: "Name" },
  { id: 9, name: "Last Name" },
  { id: 9, name: "Description" },
  { id: 10, name: "Created By" },
  { id: 10, name: "Updated By" },
];

export const searchProductPills = [
  { id: 1, title: "Total Amount", value: "Rs 150,000", variant: "dark" },
  { id: 1, title: "Products Found", value: "2", variant: "info" },
];

export const searchProductTableColumns = [
  { id: 1, name: "#" },
  { id: 2, name: "ID" },
  { id: 3, name: "Amount" },
  { id: 4, name: "Date" },
  { id: 5, name: "Description" },
  { id: 6, name: "Created By" },
  { id: 7, name: "Updated By" },
];

export const searchProductTableRows = [
  {
    id: 1,
    col1: 1,
    col2: "P001",
    col3: "$100",
    col4: "2024-10-01",
    col5: "Product A Description",
    col6: "Admin",
    col7: "User1",
  },
  {
    id: 2,
    col1: 2,
    col2: "P002",
    col3: "$150",
    col4: "2024-10-02",
    col5: "Product B Description",
    col6: "Manager",
    col7: "User2",
  },
  {
    id: 3,
    col1: 3,
    col2: "P003",
    col3: "$200",
    col4: "2024-10-03",
    col5: "Product C Description",
    col6: "Admin",
    col7: "User3",
  },
  {
    id: 4,
    col1: 4,
    col2: "P004",
    col3: "$250",
    col4: "2024-10-04",
    col5: "Product D Description",
    col6: "Supervisor",
    col7: "User4",
  },
];
